
import { createStore, applyMiddleware } from 'redux'
import { notificationReducer } from './Notification/NotificationReducer'
import thunk from "redux-thunk"
import logger from "redux-logger"

export const store = createStore(notificationReducer, applyMiddleware(thunk, logger))

// store.subscribe(
